module.exports = __webpack_public_path__ + "img/picto-user-block.fa4e00b8.svg";